import { channelSeries } from "@/mocks/homeContent";

const icons = ["ri-file-list-3-line", "ri-archive-line", "ri-git-branch-line", "ri-file-shield-line", "ri-stack-line"];

export default function ChannelStrip() {
  return (
    <section id="review" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">专题合集 · 一站式浏览</p>
            <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">复盘与专题频道</h3>
          </div>
          <p className="hidden max-w-sm text-sm leading-relaxed text-foreground-600 md:block">
            按方法论归档，每类之下都是连续更新的完整起底档案，而非孤立快讯。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {channelSeries.map((c, i) => (
            <a
              key={c.name}
              href="#archive"
              className="group flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-primary-600 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
                <i className={`${icons[i % icons.length]} text-xl`} />
              </span>
              <div className="mt-6">
                <h4 className="font-heading text-base font-bold text-foreground-950">{c.name}</h4>
                <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{c.desc}</p>
                <p className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="font-heading text-lg font-bold text-accent-600">{c.count}</span>
                  篇档案
                  <i className="ri-arrow-right-line ml-auto transition-transform group-hover:translate-x-1" />
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}